import Vue from 'vue'
import ElementUI from 'element-ui'
import '@/styles/element-variables.scss'

Vue.use(ElementUI, { size: 'small' })
